import axios from 'axios'

class ServiceService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Alan Aguilar
  * @description Handle event for get the services PSC available from hibou.legal
  * @date 13-01-2021
  * @param {String} token
  * @returns {Object}
  * @memberof ServiceService
  */
  async getServices(token) {
    let response = await axios.get(`${this.apiUrl}/services`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }
}

export { ServiceService as default }